import { ProductV2, StoreOfferProduct } from '@common'

import { useIsLoggedIn } from '../../common/useIsLoggedIn'
import { BonusContainer } from '../_storeBase/bonus/BonusContainer'
import { Bundles } from '../_storeBase/bundles/Bundles'
import { GameContainer } from '../_storeBase/structure/GameContainer'
import { StoreContent } from '../_storeBase/structure/StoreContent'
import { StoreFrontProps } from '../types'
import Offers from './Offers/Offers'
import Passes from './Passes/Passes'

export const isStoreSpecial = (product: ProductV2) => {
  return product.type === 'offer' && product.tags?.includes('store:special')
}

export const isSeasonPass = (product: ProductV2) => {
  return !!product.contentCounts.SEASON_PASS
}

export const isNormalOffer = (product: ProductV2) => {
  return product.type === 'offer' && !isSeasonPass(product) && !isStoreSpecial(product) && !isGemPackOffer(product)
}

export const isGemPackOffer = (product: ProductV2) => {
  const contentCountEntries = Object.entries(product.contentCounts).map((entry) => ({
    type: entry[0],
    amount: entry[1],
  }))
  const nonGemEntries = contentCountEntries.filter((entry) => entry.type !== 'GEM')
  const hasGems = product.contentCounts.GEM && product.contentCounts.GEM > 0
  const hasNothingElse = nonGemEntries.every((entry) => entry.amount === undefined || entry.amount === 0)
  return hasGems && hasNothingElse
}

const BONUS_CONTAINER = true

const ClashRoyaleStoreFront = ({ products, bonusStatus }: StoreFrontProps) => {
  const loggedIn = useIsLoggedIn()

  const specials = products.filter(isStoreSpecial) as StoreOfferProduct[]
  const passes = products.filter(isSeasonPass) as StoreOfferProduct[]

  return (
    <GameContainer>
      <StoreContent>
        <Bundles bundles={specials} />
        <Passes products={passes} />
        <Offers products={products} theme="clashroyale" />
      </StoreContent>
      {BONUS_CONTAINER && loggedIn && bonusStatus && <BonusContainer bonusStatus={bonusStatus} />}
    </GameContainer>
  )
}

export default ClashRoyaleStoreFront
